import { DEFAULT_GETTERS } from '@/constants'

export default {
  ...DEFAULT_GETTERS,
  listHistoryRedeem: state => state.listHistoryRedeem,
  listGiftCode: state => state.listGiftCode,
  listGiftCodePartner: state => state.listGiftCodePartner,
  listUserRedeemHistory: state => state.listUserRedeemHistory,
}
